//===== Module-level state =====
let cookieName = "pazar3cookieSubscriptionBannerListing";
var shimmerBlocks = [];
var mainBlocks    = [];
mainBlocks.push('.form-inline');

var isLoaded;
var isCategoryChanged = false;
var isPopState        = false;
var isFormDirty       = false;

//===== Shimmer visibility toggle =====
function ApplyShimmerTopSearchControl(flag) {
    if (flag) {
        shimmerBlocks.forEach(function (item) { $(item).removeClass('hidden'); });
        mainBlocks   .forEach(function (item) { $(item).addClass   ('hidden'); });
    }
    else {
        shimmerBlocks.forEach(function (item) { $(item).addClass   ('hidden'); });
        mainBlocks   .forEach(function (item) { $(item).removeClass('hidden'); });
    }
}

//===== Read URL params back into the catProps form fields =====
function SetUrlParms(url) {
    var params = $.url(url).param();

    $.eachFormElements($('.catProps'), function () {
        var name  = $(this).prop('name');
        var key   = name;
        var value = '';
        if (params.hasOwnProperty(key)) {
            value = params[key];
        }
        TrySetValue(this, value);
    });
}

window.TrySetValue = function (element, val) {

    if ($(element).is('[type=hidden]') && $(element).is(':checkbox') && $(element).length == 2) {
        element = $(element).filter(':checkbox');
    } // fix CheckBoxFor

    if ($(element).is(':checkbox')) {
        var onlyCheckBoxes = element;
        $(onlyCheckBoxes).prop('checked', false);
        if ($(onlyCheckBoxes).length == 1) {
            if (ExecutableHelper.ToBool(val)) {
                $(onlyCheckBoxes).prop('checked', true);
            }
        }
        else {
            var arrayVal = _.isArray(val) ? val : val.split(',');
            $(onlyCheckBoxes).each(function () {
                if (arrayVal.contains($(this).val())) {
                    $(this).prop('checked', true);
                }
                else {
                    $(this).prop('checked', false);
                }
            });
        }
        return;
    }

    if ($(element).is('select[multiple]')) {
        $(element).val(val.split(','));
        return;
    }

    if ($(element).is('select') && $(element).length > 1) {
        $(_.isArray(val) ? val : val.split(',')).each(function () {
            if (this.toString() != '') // fix to not update different selects if val is empty
            {
                $('option[value="{0}"]'.f(this)).closest('select').val(this.toString());
            } //this.toString() fixed for ie < 9
        });
        return;
    }

    if ($(element).is(':radio')) {
        $($(element).prop("name").toSelectorAsName() + "[value=\"{0}\"]".f(val)).prop('checked', true);
        return;
    }

    if ($(element).isFormElement()) {
        $(element).val(val);
    }
    else {
        $(element).html(val);
    }
};

$('.car-filter-toggle')
    .on('click', function () {
        var checkbox = $('#' + $(this).attr('data-for'));
        checkbox.prop('checked', !checkbox.prop('checked'));
        $(this).trigger('none');
    })
    .on('none', function (e) {
        e.stopPropagation();
        $(this).toggleClass('selected', $('#' + $(this).attr('data-for')).prop('checked'));
    });

//===== Main document.ready handler =====
$(document).ready(function () {
    $('#SearchForm').on('change input', function () { isFormDirty = true; });

    SetUrlParms(window.location.href);

    ChangeUrl(document.title, window.location.href, false);

    if (isMobileDevice) {
        shimmerBlocks.push('.mobile-shimmer-block');
    }
    else {
        shimmerBlocks.push('.shimmer-block');
    }

    //----- One-time event bindings -----
    if (isLoaded != true) {
        isLoaded = true;


        $(document).on('click', '.link-html', function (e) {
            ShimmerClassAll();
            reloadPageByUrl(this.href);
            return false;
        });

        window.addEventListener('popstate', function (event) {
            isPopState = true;
            ShimmerClassAll();
            reloadPageByUrl(event.state.Url);
        });

        $(document).on('click', '.page-link, .page-number', function (e) {
            var pNo = $(this).attr('page-no');
            $('#Page').val(pNo);
            $('.PagingShimmer').removeClass('hidden');

            shimmerBlocks = [];
            if (isMobileDevice) {
                shimmerBlocks.push('.ShimmerBlockMobileAds');
                shimmerBlocks.push('.ShimmerBlockMobilePaging');
            }
            else {
                shimmerBlocks.push('.ShimmerBlockAds');
                shimmerBlocks.push('.ShimmerBlockPaging');
                shimmerBlocks.push('.ShimmerBlockGallery');
            }
            mainBlocks = [];
            mainBlocks.push('.ShimmeredBlockAds');
            mainBlocks.push('.ShimmeredBlockPaging');
            mainBlocks.push('.ShimmeredBlockGallery');

            globalSearchSubmit();
            window.scrollTo(0, 0);
            return false;
        });

        $(document).on('click', '.tab-link', function (e) {
            var value = $(this).attr('data-value');
            var key   = $(this).attr('data-key');
            if (key == 'CountTag')
                $('#Private').val(value);
            else
                $('#Sort').val(value);

            shimmerBlocks = [];
            if (isMobileDevice) {
                shimmerBlocks.push('.ShimmerBlockMobileAds');
                shimmerBlocks.push('.ShimmerBlockMobilePaging');
            }
            else {
                shimmerBlocks.push('.ShimmerBlockAds');
                shimmerBlocks.push('.ShimmerBlockPaging');
                shimmerBlocks.push('.ShimmerBlockGallery');
            }
            mainBlocks = [];
            mainBlocks.push('.ShimmeredBlockAds');
            mainBlocks.push('.ShimmeredBlockPaging');
            mainBlocks.push('.ShimmeredBlockGallery');

            globalSearchSubmit();
            return false;
        });

        $(document).on('change', '.mobile-adslisting-filters select', function () {
            var value = $(this).val();
            var key   = $(this).attr('data-key');
            if (key == 'CountTag')
                $('#Private').val(value);
            else
                $('#Sort').val(value);

            shimmerBlocks = [];
            if (isMobileDevice) {
                shimmerBlocks.push('.ShimmerBlockMobileAds');
                shimmerBlocks.push('.ShimmerBlockMobilePaging');
            }
            else {
                shimmerBlocks.push('.ShimmerBlockAds');
                shimmerBlocks.push('.ShimmerBlockPaging');
                shimmerBlocks.push('.ShimmerBlockGallery');
            }
            mainBlocks = [];
            mainBlocks.push('.ShimmeredBlockAds');
            mainBlocks.push('.ShimmeredBlockPaging');
            mainBlocks.push('.ShimmeredBlockGallery');

            globalSearchSubmit();
            return false;
        });

        $(document).on('change', '.submit-click-category', function () {
            RestProperties();
            var url = $(this).attr('data-Url');
            if (url == '' || url == null || url == undefined) {
                ShimmerClassAll();
                isCategoryChanged = true;
                $('#Page').val('');

                globalSearchSubmit();
            }
            else {
                $(this).attr('data-Url', '');
            }
        });

        $('#Search').on("keypress", function (e) {
            if (e.keyCode == 13) {
                ShimmerClassAll();
                $('#Page').val('');
                globalSearchSubmit();
                return false; // prevent the button click from happening
            }
        });

        $(document).on('change', '.submit-click', function () {
            ShimmerClassAll();
            $('#Page').val('');
            globalSearchSubmit();
        });

        $(document).on('click', '.submit-search-trigger-click', function () {
            ShimmerClassAll();
            globalSearchSubmit();
        });

        $(document).on('change', '.submit-search-trigger-change-value', function () {
            ShimmerProperties();
            globalSearchSubmit();
        });

        function ShimmerProperties() {
            shimmerBlocks = [];
            if (isMobileDevice) {
                shimmerBlocks.push('.ShimmerBlockMobileAds');
                shimmerBlocks.push('.ShimmerBlockMobilePaging');
            }
            else {
                shimmerBlocks.push('.ShimmerBlockCount');
                shimmerBlocks.push('.ShimmerBlockAds');
                shimmerBlocks.push('.ShimmerBlockPaging');
                shimmerBlocks.push('.ShimmerBlockCategoriesLinks');
                shimmerBlocks.push('.ShimmerBlockGallery');
            }
            mainBlocks = [];
            mainBlocks.push('.ShimmeredBlockCount');
            mainBlocks.push('.ShimmeredBlockCategoriesLinks');
            mainBlocks.push('.ShimmeredBlockAds');
            mainBlocks.push('.ShimmeredBlockPaging');
            mainBlocks.push('.ShimmeredBlockGallery');
        }

        $(document).on('change', '.submit-search-trigger-change-option select', function () {
            ShimmerProperties();
            globalSearchSubmit();
        });

        $(document).on('change', '.submit-search-trigger-change-option input[type=radio]', function () {
            ShimmerProperties();
            globalSearchSubmit();
        });

        $(document).on('change', '.submit-search-trigger-change-checkbox', function () {
            ShimmerProperties();
            globalSearchSubmit();
        });

        $(document).on('change', '.submit-search-trigger-change-checkbox input[type=checkbox]', function () {
            ShimmerProperties();
            globalSearchSubmit();
        });
    }

    var isStartedSearch = false;

    function globalSearchSubmit() {
        forceSearch();
    }


    //===== AJAX cache =====
    const ajaxCache = {
        data: {},
        set: function (key, value, cacheDuration = 60000) {
            this.data[key] = {
                value:     value,
                timestamp: Date.now(),
                expiresIn: cacheDuration // 1 hour in milliseconds
            };
        },
        get: function (key) {
            const item = this.data[key];
            if (!item) return null;

            // Check if expired
            if (Date.now() - item.timestamp > item.expiresIn) {
                delete this.data[key];
                return null;
            }
            return item.value;
        },
        hasValid: function (key) {
            return this.get(key) !== null;
        }
    };

    function loadWithCache(url, params, cacheDuration = 90000, onSuccess, onFail, httpCache = false) {
        const cacheKey       = url + JSON.stringify(params);
        const cachedContent  = sessionStorage.getItem('cached_' + cacheKey);

        // Check sessionStorage cache first (persists across page refreshes)
        if (cachedContent) {
            try {
                const cachedData = JSON.parse(cachedContent);

                if (Date.now() - cachedData.timestamp < cacheDuration) {
                    console.log('Loading from sessionStorage cache');
                    AjaxSuccess(cachedData.data, cacheKey, true);
                    return;
                }
            } catch (e) {
                console.warn('SessionStorage cache invalid:', e);
            }
        }

        // Check memory cache next (for same-session requests)
        if (ajaxCache.hasValid(cacheKey)) {
            const cachedContent = ajaxCache.get(cacheKey);

            if (cachedContent) {
                AjaxSuccess(cachedContent, cacheKey, true);
                return;
            }
        }

        // No cache found, make AJAX call
        return $.ajax({
            url:     url,
            data:    params,
            cache:   httpCache,
            timeout: 1000 * 50,
            success: (data) => {
                onSuccess(data, cacheKey);
            },
            error: (xhr, status, error) => {
                console.error('AJAX failed:', error);
                onFail(error);
                // Handle error appropriately
            }
        });
    }

    //===== Page navigation handlers =====
    function reloadPageByUrl(url) {

        window.scrollTo(0, 0);

        ApplyShimmerTopSearchControl(true);
        window.VideoCarousel && VideoCarousel.shimmer();

        loadWithCache(
            url,
            null,
            90000,
            (data, cacheKey) => {
                try {
                    subCategory = "";
                    isCategoryChanged = $("#CategoryId").val() != data.Result.Query.CategoryId;
                    $("#CategoryId").val(data.Result.Query.CategoryId);
                    $("#LocationId").val(data.Result.Query.LocationId);
                    $("#CarMake")   .val(data.Result.Query.CarMake);
                    $("#CarGroup")  .val(data.Result.Query.CarGroup);
                    $("#CarModel")  .val(data.Result.Query.CarModel);
                    $("#Search")    .val(data.Result.Query.Search);

                    if (data.Result.Query.SubCategory != null) {
                        subCategory = data.Result.Query.SubCategory;
                        $("#SubCategory").val(subCategory);
                    }
                    if (isCategoryChanged) {
                        $("#CategoryId").attr('data-Url', data.Result.FullUrl);
                        $("#CategoryId").val(data.Result.Query.CategoryId).trigger('change');
                        isCategoryChanged = false;
                    }
                    else {
                        isCategoryChanged = true;
                    }
                    $('#Page').val(data.Result.Query.Page);
                    AjaxSuccess(data, cacheKey, false);

                    // Was previously wrapped in setTimeout(SetUrlParms(...), 2000) — that's
                    // a classic no-op (the function is invoked immediately, undefined is
                    // passed to setTimeout). Calling it directly preserves the actual
                    // current behavior; see notes if you want the original 2s delay back.
                    SetUrlParms(data.Result.FullUrl);

                } catch (e) {
                    window.location.href = url;
                }
            },
            (data) => {
                ApplyShimmerTopSearchControl(false);
                window.VideoCarousel && VideoCarousel.restore();
            }
        );
    }

    function forceSearch() {
        formSubmit();
    }

    $("#global-search-button").click(function () {
        $('#Page').val('');
        ShimmerClassAll();
        formSubmit();
    });

    function ShimmerClassAll() {
        shimmerBlocks = [];

        if (isMobileDevice) {
            shimmerBlocks.push('.mobile-shimmer-block');
            shimmerBlocks.push('.ShimmerBlockMobilePaging');
        }
        else {
            shimmerBlocks.push('.shimmer-block');
            shimmerBlocks.push('.ShimmerBlockPaging');
        }
        mainBlocks = [];
        mainBlocks.push('.form-inline');
    }

    function ApplyShimmerImages() {
        $('.ShimmerImgBlock').removeClass('hidden');
        $('.ShimmeredImgBlock').addClass('visually-hidden-shimmer');
    }

    function RestProperties() {
        $('input[name=PropChkboxes]').prop('checked', false);
        $("[name=Prop]")     .val('');
        $("[name=PriceFrom]").val('');
        $("[name=PriceTo]")  .val('');
    }

    function formSubmit(url) {
        var data = null;
        var httpCache = false;

        if (url == null || url == 'undefined') {
            url  = window.pzSearch.searchUrl;
            data = $('#SearchForm').serialize();
            httpCache = true;
        }

        ApplyShimmerTopSearchControl(true);
        window.VideoCarousel && VideoCarousel.shimmer();

        loadWithCache(
            url,
            data,
            90000,
            (data, cacheKey) => {
                AjaxSuccess(data, cacheKey, false);
            },
            (data) => {
                ApplyShimmerTopSearchControl(false);
                window.VideoCarousel && VideoCarousel.restore();
            },
            httpCache
        );
    }

    //===== Apply AJAX response =====
    function AjaxSuccess(data, cacheKey = null, fromCache = false) {
        // Cache the response if key provided
        if (cacheKey && !fromCache) {
            ajaxCache.set(cacheKey, data);

            try {
                sessionStorage.setItem('cached_' + cacheKey,
                    JSON.stringify({
                        timestamp: Date.now(),
                        data:      data
                    })
                );
            } catch (e) {
                console.warn('Failed to cache content:', e);
            }
        }

        if (isCategoryChanged) {
            isCategoryChanged = false;
            RestProperties();
        }

        ChangeUrl(data.Result.MetaTitle, data.Result.FullUrl);
        ChangeMeta(data.Result);
        var videoCarousel = $('#videoCarouselContainer').detach();
        $('#OpensearchListingSearchAdsQuery').html(data.Html);
        if (videoCarousel.length) {
            $('.video-carousel-slot').first().append(videoCarousel);
            window.VideoCarousel && VideoCarousel.restore();
        }

        setTimeout(() => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setupPagination();
                });
            });
        }, 0);

        ApplyShimmerTopSearchControl(false);
        ApplyShimmerImages();

        try {
            if (data.hrefLang != null && data.hrefLang != undefined) {
                var langs = data.hrefLang;
                for (var i = 0; i < langs.length; i++) {
                    $('.' + langs[i].key).attr('href', langs[i].value);
                }
            }
        } catch (e) {
        }

        $('#AdTypesGlobal').val(data.Result.Query.AdTypesString);
        parseAdTypes();

        if (window.pzSearch.gamEnabled && $.fn.loadSide) {
            $('#OpensearchListingSearchAdsQuery')
                .loadSide(
                    data.Result.Query.Search,
                    data.Result.Ads.CategoryString,
                    data.Result.Ads.LocationString,
                    data.Result.Query.Private);
        }

        BindRecentSearch(data);

        if (data.Gallery !== undefined) {
            $('.gallery').toggleClass('hide', !data.Gallery);
            if (data.Gallery) {
                $('#galleryDiv').html(data.Gallery);
            }
        }
        else {
            LoadGallery();
        }
    }

    function BindRecentSearch(data) {
        saveRecentSearch(
            data.Result.Query.Search,
            $("#CategoryId option:selected").text().trim(),
            $("#LocationId option:selected").text().trim(),
            data.Result.Ads);

        var input = getRecentSearch('saveRecentSearch');
        var target = $('.visited-savedsearch-left');
        if (target.length && input && Array.isArray(input) && input.length > 0) {
            var esc = function (s) { return $('<div>').text(s == null ? '' : s).html().replace(/"/g, '&quot;'); };
            var html = '<div><p><h4>' + esc(window.pzSearch.recentSearchesTitle) + '</h4></p></div><div class="line-ul">';
            input.forEach(function (item) {
                html += '<p><picture><source srcset="' + window.pzSearch.recentSearchWebp + '" type="image/webp" />'
                    + '<img src="' + window.pzSearch.recentSearchPng + '" alt="' + esc(item.Text) + '" width="15" height="10" /></picture>'
                    + '<a href="' + esc(item.Value) + '"><span class="line-li">' + esc(item.Text) + '</span></a></p>';
            });
            target.html(html + '</div>');
        }
    }

    //===== History (pushState / replaceState) =====
    function ChangeUrl(title, url1, shouldPushState = true) {
        if (!isPopState && typeof (history.pushState) != "undefined") {
            var obj = {
                Title: title,
                Url:   url1
            };

            try {
                if (shouldPushState) {
                    history.pushState(obj, title, url1);
                } else {
                    history.replaceState(obj, title, url1);
                }
            } catch (e) {
                console.error("Failed to change URL:", e);
            }
        } else {
            isPopState = false;
        }

        // Read at click time by the ad details back button. It cannot use the url baked into
        // that page: ad details is client-cached for 5 minutes, so a second visit to the same
        // ad serves the first visit's markup.
        try {
            sessionStorage.setItem('pz-last-listing-url', window.location.href);
        } catch (e) {
        }
    }

    function ChangeMeta(result) {
        $(document).prop('title', result.MetaTitle);
        $('meta[name=title]')      .attr('content', result.MetaTitle);
        $('meta[name=description]').attr('content', result.MetaTitle);
    }

    //===== Sitemap link refresh on category/location change =====
    $("#CategoryId").on("reset-keyword-link", function () {
        changeSitemapKeywordsLink();
        changeSitemapCategoriesLink();
    });

    $("#LocationId").on("reset-category-link", function () {
        changeSitemapCategoriesLink();
    });

    function changeSitemapCategoriesLink() {
        var requestData = {
            locationId: $('#LocationId').val(),
            categoryId: $('#CategoryId').val(),
        };

        $.ajax({
            url:         window.pzSearch.categoriesLinkUrl,
            type:        "post",
            data:        JSON.stringify(requestData),
            contentType: "application/json",
            processData: false,
        })
        .done(function (data) {
            $("#sitemap-categories-id").attr("href", data);
        })
        .fail(function (data) { });
    }

    function changeSitemapKeywordsLink() {
        var requestData = {
            categoryId: $('#CategoryId').val(),
        };

        var catName = $("#CategoryId option:selected").text().trim();

        var linkName;
        if (catName != undefined && catName != '' && $('#CategoryId').val() != 0) {
            linkName = window.pzSearch.keywordsLinkText + " " + window.pzSearch.inText + " " + catName;
        }
        else {
            linkName = window.pzSearch.keywordsLinkText;
        }

        $.ajax({
            url:         window.pzSearch.keywordsLinkUrl,
            type:        "post",
            data:        JSON.stringify(requestData),
            contentType: "application/json",
            processData: false,
        })
        .done(function (data) {
            $("#sitemap-keywords-id").attr("href", data);
            $("#sitemap-keywords-id").text(linkName);
        })
        .fail(function (data) { });
    }

});

//===== Sub-category restore helper (called from Razor-emitted code) =====
var subCategory = "";

function onloadSubCategory() {
    if (subCategory != "") {
        $("#SubCategory").val(subCategory);
        subCategory = "";
    }
}

//===== Gallery side-load (desktop only) =====
function LoadGallery() {

    if (!isMobileDevice && !window.matchMedia('(max-width: 991px)').matches) {
        shimmerBlocks = [];
        shimmerBlocks.push('.ShimmerBlockGallery');

        mainBlocks = [];
        mainBlocks.push('.ShimmeredBlockGallery');

        ApplyShimmerTopSearchControl(true);
        $.ajax({
            url:     window.pzSearch.galleryUrl,
            type:    "GET",
            data:    $('#SearchForm').serialize(),
            cache:   true,
            timeout: 1000 * 50
        })
        .done(function (data) {
            if (data.Data.length > 0) {
                $('.gallery').removeClass('hide');
                $('#galleryDiv').html(data.Gallery);
            }
            else {
                $('.gallery').addClass('hide');
            }
            ApplyShimmerTopSearchControl(false);
        })
        .fail(function (data) {
            ApplyShimmerTopSearchControl(false);
        });
    }
}

//===== Window load: kick off gallery, decide whether to show VIP banner =====
$(window).load(function () {
    LoadGallery();

    var newDate = new Date().toDateString();
    var x = getCookie(cookieName);
    if (x) {
        const dateString = x.toString(); // Assuming this is the formatted date string
        const cookieDate = new Date(dateString);
        if (cookieDate.toDateString() < newDate) {
            $('.vip-services-user-banner').removeClass("hidden");
            $('.vip-services-user-banner').addClass("show");
        }
    }
    else {
        $('.vip-services-user-banner').removeClass("hidden");
        $('.vip-services-user-banner').addClass("show");
    }
});

//===== Cookie helpers =====
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

window.cookieName = cookieName;
window.ApplyShimmerTopSearchControl = ApplyShimmerTopSearchControl;
window.SetUrlParms = SetUrlParms;
window.onloadSubCategory = onloadSubCategory;
window.LoadGallery = LoadGallery;
window.setCookie = setCookie;
window.getCookie = getCookie;
